import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import { themr } from 'react-css-themr';
import historyIcon from 'images/ic-history-black-24-px-copy-4.svg';
import styles from 'styles/payRateHistory.scss';
import { ResourceDetailsCardElement } from 'components/ResourceCardElements';

const PayRateElement = (props) => {
  const { handleHistory, theme, rate, component, ...rest } = props;
  const iconClass = cx(theme.button, theme.detailsView);
  const localizedRate = Number(rate.replace('$', '')).toLocaleString('en-US', {
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const displayRate = `$${localizedRate}`;
  const Component = component || ResourceDetailsCardElement;

  return (
    <Component theme={theme} {...rest} >
      <div className={styles.wrapper}>
        <span className={theme.rateValue}>{displayRate}</span>
        <button onClick={handleHistory} className={iconClass}>
          <img src={historyIcon} alt="history" className={theme.historyIcon} />
        </button>
      </div>
    </Component>
  );
};

PayRateElement.defaultProps = {
  rate: '0',
};

PayRateElement.propTypes = {
  handleHistory: PropTypes.func,
  theme: PropTypes.object,
  rate: PropTypes.string,
  component: PropTypes.any,
};

export default themr('PayRateElement', styles)(PayRateElement);



// WEBPACK FOOTER //
// ./client/app/shared/components/PayRateElement/index.jsx